import moment from 'moment';
import { Typography } from '@mui/material';

const DispositionInfo = (props: any) => {
  const { record } = props?.others;

  const dispositionBy = record?.dispositionBy ?? null;
  const dispositionOn = record?.dispositionOn ?? null;
  const dispositionReason = record?.dispositionReason ?? null;
  const dispositionNote = record?.dispositionNote ?? null;

  return (
    <div>
      {dispositionBy && (
        <Typography variant="subtitle2" gutterBottom component="div">
          <strong>Disposition By:</strong> <span>{dispositionBy}</span>
        </Typography>
      )}

      {dispositionOn && (
        <Typography variant="subtitle2" gutterBottom component="div">
          <strong>Disposition On:</strong>{' '}
          <span>
            {moment(new Date(dispositionOn)).format('MM/DD/YYYY HH:mm')}
          </span>
        </Typography>
      )}

      {dispositionReason && (
        <Typography variant="subtitle2" gutterBottom component="div">
          <strong>Disposition Reason:</strong>{' '}
          <span>{dispositionReason}</span>
        </Typography>
      )}

      {dispositionNote && (
        <Typography variant="subtitle2" gutterBottom component="div">
          <strong>Disposition Note:</strong>{' '}
          <span>{dispositionNote}</span>
        </Typography>
      )}
    </div>
  );
};

export default DispositionInfo;
